import {
    type ViewStyle,
    StyleSheet,
    Animated,
    Platform
} from "react-native";
import type {
    BadgeLettersDynamicStyleType
} from "./type";
import {
    MOTION_ICON_APPEAR_BLUR
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "row",
        flexShrink: 1,
        minWidth: 0,
        ...Platform.select({
            default: {
                direction: "ltr"
            },
            web: {
            }
        })
    }
});

export const getBadgeLetterStyle = ({
    isReduceMotionEnabled,
    spaces,
    value
}: BadgeLettersDynamicStyleType) => {
    const style: Animated.WithAnimatedValue<ViewStyle> = {
        opacity: value
    };

    if(isReduceMotionEnabled) {
        return style;
    }

    style.transform = [
        {
            translateY: value.interpolate({
                outputRange: [
                    spaces.spacingXs,
                    0
                ],
                inputRange: [
                    0,
                    1
                ]
            })
        }
    ];

    return [
        style,
        webStyle({
            filter: value.interpolate({
                outputRange: [
                    `blur(${MOTION_ICON_APPEAR_BLUR}px)`,
                    "blur(0px)"
                ],
                inputRange: [
                    0,
                    1
                ]
            }) as unknown as string
        })
    ];
};
export default stylesheet;
